import { create } from 'zustand';

type TranslatingProject = {
  projectId: string | undefined;
  language: string;
  length: number;
  source: 'questions' | 'transcripts';
  /**
   * TELV1-501 — translated-conversation count at the moment a PARTIAL
   * retry started (coverage-banner "Retry missing translations"). The
   * completion detector requires the count to EXCEED this baseline before
   * plateau-stability may complete: for a partial retry the project-wide
   * count starts high and already stable, so without the baseline the
   * detector declares success after ~4 polls while the retried
   * conversations are still translating. Undefined for full translations
   * (count starts at 0 — original behavior unchanged).
   */
  baselineCount?: number;
};

type State = {
  translatingProjects: TranslatingProject[];
};

type Action = {
  setTranslatingProjects: (
    updater: TranslatingProject[] | ((prev: TranslatingProject[]) => TranslatingProject[]),
  ) => void;
};

const useTranslationsLoadingStore = create<State & Action>((set) => ({
  translatingProjects: [],
  setTranslatingProjects: (updater) =>
    set((state) => ({
      translatingProjects:
        typeof updater === 'function' ? updater(state.translatingProjects) : updater,
    })),
}));

export default useTranslationsLoadingStore;
